import { useState, useEffect } from 'react';
import { getCurrentTenant } from '../services/tenantService';

export interface LicenciaInfo {
    activa: boolean;
    diasRestantes: number;
    estado: string;
    fechaVencimiento: string;
    tipo: string;
    fechaInicio: string;
}

export const useLicencia = () => {
    const [licencia, setLicencia] = useState<LicenciaInfo | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const fetchLicencia = async () => {
        try {
            setLoading(true);
            setError(null);

            // Obtener información del tenant actual
            const tenantActual = await getCurrentTenant();

            if (tenantActual && tenantActual.licencia) {
                const hoy = new Date();
                const fechaVencimiento = new Date(tenantActual.licencia.fechaVencimiento);
                const diferencia = fechaVencimiento.getTime() - hoy.getTime();
                const diasRestantes = Math.ceil(diferencia / (1000 * 60 * 60 * 24));

                setLicencia({
                    activa: tenantActual.licencia.estado === 'activa' && diasRestantes > 0,
                    diasRestantes,
                    estado: tenantActual.licencia.estado,
                    fechaVencimiento: tenantActual.licencia.fechaVencimiento,
                    tipo: tenantActual.licencia.tipo,
                    fechaInicio: tenantActual.licencia.fechaInicio
                });
            } else {
                setLicencia(null);
            }
        } catch (err) {
            console.error('Error obteniendo información de licencia:', err);
            setError(err instanceof Error ? err.message : 'Error desconocido');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLicencia();
    }, []);

    return {
        licencia,
        loading,
        error,
        refetch: fetchLicencia
    };
};
